import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const initialState = {
  authToken: Cookies.get("authToken") || null,
  loading: true, 
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    isloading : (state) => {
      state.loading = true;
    },
    loaded : (state) => {
      state.loading = false; 
    },
    login: (state, action) => {
      state.authToken = action.payload;
      Cookies.set("authToken", action.payload, { expires: 1 });
      state.loading = false;
    },
    logout: (state) => {
      state.authToken = null;
      Cookies.remove("authToken");
      state.loading = false;
    },
  },
});

export const { login, logout, loaded, isloading  } = authSlice.actions;

export default authSlice.reducer;
